// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
    min-width: 520px;
    padding: 2px 24px !important;
    background-color: #f0f0f0;
}

mat-dialog-actions {
    background-color: #f0f0f0;
    padding: 8px 24px !important;
    justify-content: flex-end;
}

.content {
    padding: 16px;
    border-radius: 4px;
}

.step-label {
    font-size: 13px;
    margin-bottom: 10px;
}

.search-actions {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
}

.search-spinner {
    text-align: center;
    padding: 16px 0;
}

.no-results {
    text-align: center;
    font-size: 13px;
    margin: 8px 0 12px;
}

.results-table-wrapper {
    max-height: 280px;
    overflow-y: auto;
    border: 1px solid #ccc;
    margin-bottom: 8px;
}

.results-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.results-table th {
    background: #e9ecef;
    padding: 5px 8px;
    text-align: left;
    border-bottom: 1px solid #ccc;
    position: sticky;
    top: 0;
    z-index: 1;
}

.results-table td {
    padding: 4px 8px;
    border-bottom: 1px solid #eee;
    white-space: nowrap;
}

.results-table tbody tr:hover {
    background-color: #f0f4ff;
    cursor: context-menu;
}

.results-table tbody tr.selected {
    background-color: #cce0ff;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/well-search-dialog/well-search-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["mat-dialog-content {\n    min-width: 520px;\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n}\n\nmat-dialog-actions {\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n    justify-content: flex-end;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n}\n\n.step-label {\n    font-size: 13px;\n    margin-bottom: 10px;\n}\n\n.search-actions {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 12px;\n}\n\n.search-spinner {\n    text-align: center;\n    padding: 16px 0;\n}\n\n.no-results {\n    text-align: center;\n    font-size: 13px;\n    margin: 8px 0 12px;\n}\n\n.results-table-wrapper {\n    max-height: 280px;\n    overflow-y: auto;\n    border: 1px solid #ccc;\n    margin-bottom: 8px;\n}\n\n.results-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.results-table th {\n    background: #e9ecef;\n    padding: 5px 8px;\n    text-align: left;\n    border-bottom: 1px solid #ccc;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.results-table td {\n    padding: 4px 8px;\n    border-bottom: 1px solid #eee;\n    white-space: nowrap;\n}\n\n.results-table tbody tr:hover {\n    background-color: #f0f4ff;\n    cursor: context-menu;\n}\n\n.results-table tbody tr.selected {\n    background-color: #cce0ff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
